const LibNativeSlider = function(selector, parent) {
    let isDown = false, startX, scrollLeft;
    let progress = parent.querySelector("[data-lib-ns-progress]");
    let prev = parent.querySelector("[data-lib-ns-prev]");
    let next = parent.querySelector("[data-lib-ns-next]");
    let items = [...selector.children];
    let edgeOffset = 24;
    let activeSlide = items[0];

    if (typeof activeSlide === "undefined") {
        return;
    }

    const getScrollPadding = () => parseInt(getComputedStyle(selector).scrollPaddingLeft) || 0;
    const getMaxScrollLeft = () => Math.max(0, selector.scrollWidth - selector.clientWidth);

    const updateState = () => {
        items = [...selector.children];

        if (items.length === 0) {
            return;
        }

        let scrollPadding = getScrollPadding();
        let maxScrollLeft = getMaxScrollLeft();
        let nextActiveSlide = items[0];
        let nextActiveDistance = Math.abs((items[0].offsetLeft - scrollPadding) - selector.scrollLeft);

        for (let i = 1; i < items.length; i++) {
            let distance = Math.abs((items[i].offsetLeft - scrollPadding) - selector.scrollLeft);

            if (distance < nextActiveDistance) {
                nextActiveSlide = items[i];
                nextActiveDistance = distance;
            }
        }

        if (activeSlide !== nextActiveSlide) {
            activeSlide.classList.remove("state--active");
            activeSlide = nextActiveSlide;
        }

        activeSlide.classList.add("state--active");

        if (progress !== null) {
            progress.value = ((selector.scrollLeft + selector.clientWidth) / selector.scrollWidth * 100).toFixed(2);
        }

        parent.classList.remove('lib-ns-start', 'lib-ns-end');

        if (selector.scrollLeft <= edgeOffset) {
            parent.classList.add('lib-ns-start');
        } else if (selector.scrollLeft >= maxScrollLeft - edgeOffset) {
            parent.classList.add('lib-ns-end');
        }

        if (prev !== null && next !== null) {
            if (selector.scrollLeft >= maxScrollLeft - edgeOffset) {
                next.setAttribute('disabled', 'disabled');
            } else {
                next.removeAttribute('disabled');
            }

            if (selector.scrollLeft <= edgeOffset) {
                prev.setAttribute('disabled', 'disabled');
            } else {
                prev.removeAttribute('disabled');
            }
        }
    };

    let grabbing = () => {
        isDown = false;
        selector.classList.remove('is--grabbing');
        selector.scrollLeft = selector.scrollLeft - 1;
    };

    selector.addEventListener('mouseleave', grabbing);

    selector.addEventListener('mouseup', grabbing);

    selector.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - selector.offsetLeft;
        scrollLeft = selector.scrollLeft;
    });

    selector.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();

        const x = e.pageX - selector.offsetLeft;
        const walk = (x - startX) * 1.25;
        selector.classList.add('is--grabbing');
        selector.scrollLeft = scrollLeft - walk;

        selector.ondragstart = (dragEvent) => {
            dragEvent.preventDefault();
        };
    });

    selector.addEventListener("scroll", () => {
        updateState();
    }, { passive: true });

    if (progress !== null) {
        progress.addEventListener("click", (e) => {
            selector.scrollLeft = (selector.scrollWidth / 100) * (e.clientX - e.target["offsetLeft"]) / e.target["clientWidth"] * 100;
        });
    }

    if (prev !== null && next !== null) {
        prev.addEventListener("click", () => {
            let currentIndex = items.indexOf(activeSlide);
            let targetIndex = Math.max(0, currentIndex - 1);
            selector.scroll({ left: items[targetIndex].offsetLeft - getScrollPadding(), behavior: "smooth" });
        });

        next.addEventListener("click", () => {
            let currentIndex = items.indexOf(activeSlide);
            let targetIndex = Math.min(items.length - 1, currentIndex + 1);
            selector.scroll({ left: items[targetIndex].offsetLeft - getScrollPadding(), behavior: "smooth" });
        });
    }

    updateState();
};
